import React from "react"
import PropTypes from "prop-types"
import 'chart.js/auto'
import { Line } from 'react-chartjs-2'
import Widget from './Widget'
import {COLORS} from './config'
import {hexToRgba} from './utils'

const tooltipLabel = (item, data) => {
  let label = data.datasets[item.datasetIndex].label
  let value = new Intl.NumberFormat(dashboardLocale, currencyFormat).format(item.yLabel)
  return `${label}: ${value}`
}

const tooltipFooter = (items, data) => {
  let min = Math.min(...items.map((item) => item.yLabel))
  let max = Math.max(...items.map((item) => item.yLabel))
  let value = Math.abs(max - min) / (max == 0 ? '1' : max)
  return `Margin: ${Math.round(value * 100)}%`
}

class WidgetRevenue extends Widget {
  componentDidMount() {
    fetch(this.props.dataURL)
      .then((response) => response.json())
      .then((json) => this.setState({ data: json, loading: false }))
  }

  renderChart () {
    let { data } = this.state
    if (!data || data.length == 0) return;
    let chartData = {
      labels: Object.keys(Object.values(data)[0]),
      datasets: Object.entries(data).map((dataset, index) => {
        return {
          label: dataset[0],
          data: Object.values(dataset[1]),
          borderColor: COLORS[index],
          backgroundColor: hexToRgba(COLORS[index], 0.2),
          borderWidth: 1,
          pointBorderWidth: 2,
          pointRadius: 2,
          pointHoverRadius: 3,
          showLine: true
        }
      })
    }

    return(
      <Line
        data={chartData}
        height={100}
        options={{
          plugins: {
            legend: { display: false} },
            tooltips: {
              callbacks: {
                label: tooltipLabel,
                footer: tooltipFooter
              },
              intersect: false,
              mode: 'index'
            }
        }}
      />)
  }

  renderBody () {
    return(
      <React.Fragment>
      {this.renderChart()}
      </React.Fragment>
    )
  }

  renderFooter () {
    return null
  }
}

export default WidgetRevenue
